import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";

import { useReduxSelector } from "@hooks/useReduxSelector";
import {
  Controller,
  useFormContext,
  /*, useFieldArray*/
} from "react-hook-form";

import InputWithAddOptions from "@components/input/InputWithAddOptions";
import BlackTooltip from "@components/tooltip/BlackTooltip";

import { checkEnterpriseId } from "@helpers/_functions";

import useHealth from "./hooksHealth";
import { useUserPermission } from "@hooks/users";

export default function SharedHealth({ setSuperZIndex, readOnly, isEnterprisePage }) {
  const { t } = useTranslation("pages.employés.healthPrecision");
  const { deleteHealth, upsertOption } = useHealth();
  const allergies = useReduxSelector(
    ({ enterpriseEmployeData: { allergies } }) => allergies?.list,
  );
  const foodPreferences = useReduxSelector(
    ({ enterpriseEmployeData: { foods } }) => foods?.list,
  );
  const { control } = useFormContext();
  const { canAccessHealthAllergiesFoodPrefs } = useUserPermission();

  const readOnlyAccess = useMemo(() => {
    return isEnterprisePage ? readOnly : (readOnly && !canAccessHealthAllergiesFoodPrefs);
  }, [readOnly, isEnterprisePage, canAccessHealthAllergiesFoodPrefs])

  return (
    <div
      className="arh-flex arh-w-full arh-items-center arh-pb-[2rem] arh-pl-[5.8rem] arh-pr-[1rem] tablet-850:arh-flex-wrap tablet-850:arh-items-start tablet-850:arh-justify-start tablet-850:arh-gap-x-5 tablet-850:arh-gap-y-0 tablet-850:!arh-pl-[2.5rem] tablet-850:!arh-pr-[1rem]"
    >
      <div className="arh-mb-[1.75rem] arh-mr-[1.875rem] arh-flex-[0.25_0.25_0] tablet-850:!arh-mr-0 tablet-850:arh-min-w-0 tablet-850:!arh-w-[calc(50%_-_0.625rem)] tablet-850:!arh-flex-[0_0_calc(50%_-_0.625rem)]">
        <Controller
          control={control}
          name="healthPrecision.allergies"
          defaultValue={null}
          //rules={{ required: true }}
          render={({
            field: { onChange, value, name },
            fieldState: { invalid },
          }) => (
            <>
              <label
                className={`arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium 
                ${readOnlyAccess ? "arh-text-greyDisabledText" : invalid ? "arh-text-[#F60A20]" : "arh-text-black"}
                  `}
              >
                {t("Allergies")}
              </label>
              <BlackTooltip
                title={(value || []).map((item) => item?.name).join(", ")}
                placement="top"
              >
                <span className="arh-inline-block arh-w-full">
                   <InputWithAddOptions
                defaultText={t("Allergies")}
                optionsList={allergies}
                secondDefaultText={t("Ajouter")}
                name={name}
                value={value}
                optionListLabel="name"
                onChange={onChange}
                addItem={(body) =>
                  upsertOption(
                    {
                      ...body,
                      type: "allergy",
                      Enterprise: checkEnterpriseId(),
                    },
                    "allergy",
                  )
                }
                editItem={(body) =>
                  upsertOption(
                    {
                      ...body,
                      type: "allergy",
                      Enterprise: checkEnterpriseId(),
                    },
                    "allergy",
                  )
                }
                deleteItem={(body) => deleteHealth(body, "allergy")}
                validateDropdown={invalid}
                multiple
                setSuperZIndex={setSuperZIndex}
                showAction={isEnterprisePage}
                hideAdd={!isEnterprisePage}
                disabled={readOnlyAccess}
              />
              </span>
              </BlackTooltip>
            </>
          )}
        />
      </div>
      <div className="arh-mb-[1.75rem] arh-mr-[1.875rem] arh-flex-[0.25_0.25_0] tablet-850:!arh-mr-0 tablet-850:arh-min-w-0 tablet-850:!arh-w-[calc(50%_-_0.625rem)] tablet-850:!arh-flex-[0_0_calc(50%_-_0.625rem)]">
        <Controller
          control={control}
          name="healthPrecision.foodPreferences"
          defaultValue={null}
          //rules={{ required: true }}
          render={({
            field: { onChange, value, name },
            fieldState: { invalid },
          }) => (
            <>
              <label
                className={`arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium 
                ${readOnlyAccess ? "arh-text-greyDisabledText" : invalid ? "arh-text-[#F60A20]" : "arh-text-black"}
                `}
              >
                {t("Préférences alimentaires")}
              </label>
              <BlackTooltip
                title={(value || []).map((item) => item?.name).join(", ")}
                placement="top"
              >
                <span className="arh-inline-block arh-w-full">
                  <InputWithAddOptions
                defaultText={t("Préférences alimentaires")}
                optionsList={foodPreferences}
                secondDefaultText={t("Ajouter")}
                name={name}
                value={value}
                optionListLabel="name"
                onChange={onChange}
                showAction={isEnterprisePage}
                hideAdd={!isEnterprisePage}
                addItem={(body) =>
                  upsertOption(
                    {
                      ...body,
                      type: "foodPreference",
                      Enterprise: checkEnterpriseId(),
                    },
                    "preferenceFood",
                  )
                }
                editItem={(body) =>
                  upsertOption(
                    {
                      ...body,
                      type: "foodPreference",
                      Enterprise: checkEnterpriseId(),
                    },
                    "preferenceFood",
                  )
                }
                deleteItem={(body) => deleteHealth(body, "preferenceFood")}
                validateDropdown={invalid}
                multiple
                setSuperZIndex={setSuperZIndex}
                disabled={readOnlyAccess}
              />
              </span>
              </BlackTooltip>

            </>
          )}
        />
      </div>
    </div>
  );
}
